import { React, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReactLoading from "react-loading";

import "./MainBox.scss";
import Product from "../Product/Product";
import JSlider from "../../components/Slider/JSlider";
import JSlider2 from "../../components/Slider2/JSlider2";
import { getData } from "../Services/APIService";
import config from "../Services/config.json";
import { updateCustomer } from "../../ReduxActions/customerAction";
import JButton from "../../components/Button/JButton";

const MainBox = ({ serviceType }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const customer = useSelector((state) => state.customer);
  const [getStartSlider, setStartSlider] = useState(true);
  const [getEndSlider, setEndSlider] = useState(false);

  useEffect(() => {
    handleLoadInfo("");
  }, []);

  const handleShowAll = (e) => {
    e.preventDefault();

    dispatch(
      updateCustomer({
        serviceType: serviceType,
        serviceCode: 0,
        checkPhone: 0,
        phone: "",
      }),
    );

    console.log("StoreLog: ", serviceType);

    if (serviceType != 1) history.push("/serviceShow");
    else history.push("/checkPhone");
  };

  const handleSelectPackage = (code, selectedServiceType) => {
    dispatch(
      updateCustomer({ serviceCode: code, serviceType: selectedServiceType }),
    );
    if (selectedServiceType === 1) history.push("/checkPhone");
    else history.push("/serviceShow");
  };

  //####################################################################
  const [getItems, setItems] = useState([]);
  const [getItemsCount, setItemsCount] = useState(0);
  const [getNormalItemsCount, setNormalItemsCount] = useState(0);
  const [getLoading, setLoading] = useState(true);

  const info = {
    token: config.APIKey,
    tag: serviceType === 0 ? 2 : serviceType === -1 ? 3 : 4,
    type: serviceType === -1 ? 0 : serviceType,
    category: 0,
    duration: 0,
    traffic: 0,
    speed: 0,
    modem: 2,
    index: 1,
    size: 6,
    selectedService: 0,
  };

  const handleLoadInfo = async (params) => {
    try {
      const { data } = await getData("store/getPackages", info);

      if (data.Result !== 4 && data.Message !== null) {
        toast.error(data.Message, {
          position: "bottom-left",
          closeButton: true,
          closeOnClick: true,
        });
      } else if (data.Result !== 4) {
        //toast.error("خطایی رخ داده است",{position:'bottom-left',closeButton:true,closeOnClick:true});
        console.log("StoreLog: ", "خطایی رخ داده است");
      } else {
        setItems(data.packages);
        setNormalItemsCount(data.normalCount);
        setItemsCount(data.all);
      }
    } catch (ex) {
      // toast.error("مشکلی پیش آمده.", {
      //     position: "bottom-left",
      //     closeOnClick: true
      // });
      console.log("StoreLog: ", ex.Message);
    }

    setLoading(false);
  };

  const handleSwipeChanged = (start, end) => {
    console.log("StoreLog: ", start, end);
    setStartSlider(start);
    setEndSlider(end);
  };
  //####################################################################

  const fixItem = (
    <div className="fixItem">
      {serviceType === 0 ? (
        <>
          <div className="fixicon offer"></div>
          <div className="fixItemText">
            <div className="title1">پیشنهاد ویژه</div>
            <div className="description">
              <span>
                از پیشنهادات ویژه اینترنت پرسرعت ماهان نت بهره مند شوید
              </span>
            </div>
          </div>
        </>
      ) : null}

      {serviceType === 1 && (
        <>
          <div className="fixItemText">
            <div className="title3">اینترنت</div>
            <div className="title2">ADSL</div>
            <div className="description">
              خرید سریع و آسان بسته‌های اینترنت پرسرعت ADSL2+
            </div>
          </div>
          <div className="fixicon adsl"></div>
          {/* <div className="btnShowAll" onClick={handleShowAll}>
                    <span>مشاهده همه</span>
                    <div className="fa fa-arrow-circle-left"></div>
                </div> */}
          <div className="divShowAll">
            {(getNormalItemsCount > 0 || getItemsCount > 6) && (
              <JButton
                handleClick={handleShowAll}
                title={"مشاهده همه"}
                rightIcon={"fa fa-arrow-circle-left"}
                type={"Black"}
              />
            )}
          </div>
        </>
      )}

      {serviceType === 2 && (
        <>
          <div className="fixItemText">
            <div className="title3">اینترنت</div>
            <div className="title2">TD-LTE</div>
            <div className="description">
              خرید سریع و آسان بسته‌های اینترنت نسل ۴ ثابت
            </div>
          </div>
          <div className="fixicon lte"></div>
          {/* <div className="btnShowAll" onClick={handleShowAll}>
                    <span>مشاهده همه</span>
                    <div className="fa fa-arrow-circle-left"></div>
                </div> */}
          <div className="divShowAll">
            {(getNormalItemsCount > 0 || getItemsCount > 6) && (
              <JButton
                handleClick={handleShowAll}
                title={"مشاهده همه"}
                rightIcon={"fa fa-arrow-circle-left"}
                type={"Black"}
              />
            )}
          </div>
        </>
      )}

      {serviceType === 3 && (
        <>
          <div className="fixItemText">
            <div className="title3">اینترنت</div>
            <div className="title2">فیبر نوری</div>
            <div className="description">
              خرید سریع و آسان بسته‌های اینترنت فیبر
            </div>
          </div>
          <div className="fixicon gaming"></div>
          {/* <div className="btnShowAll" onClick={handleShowAll}>
                    <span>مشاهده همه</span>
                    <div className="fa fa-arrow-circle-left"></div>
                </div> */}
          <div className="divShowAll">
            {(getNormalItemsCount > 0 || getItemsCount > 6) && (
              <JButton
                handleClick={handleShowAll}
                title={"مشاهده همه"}
                rightIcon={"fa fa-arrow-circle-left"}
                type={"Black"}
              />
            )}
          </div>
        </>
      )}

      {serviceType === 4 && (
        <>
          <div className="fixItemText">
            <div className="title3">اینترنت</div>
            <div className="title2">Gaming</div>
            <div className="description">
              خرید سریع و آسان بسته‌های اینترنت Gaming
            </div>
          </div>
          <div className="fixicon gaming"></div>
          {/* <div className="btnShowAll" onClick={handleShowAll}>
                    <span>مشاهده همه</span>
                    <div className="fa fa-arrow-circle-left"></div>
                </div> */}
          <div className="divShowAll">
            {(getNormalItemsCount > 0 || getItemsCount > 6) && (
              <JButton
                handleClick={handleShowAll}
                title={"مشاهده همه"}
                rightIcon={"fa fa-arrow-circle-left"}
                type={"Black"}
              />
            )}
          </div>
        </>
      )}
    </div>
  );

  return getItems.length != 0 && serviceType != -1 ? (
    <div
      className={`box ${serviceType === 0 ? "backColorOffer" : serviceType === 1 ? "backColorADSL" : serviceType === 2 ? "backColorLTE" : "backColorGaming"} ${getStartSlider && getEndSlider ? " startEndBox" : getStartSlider ? " startBox" : getEndSlider ? "endBox" : ""}`}
    >
      <div className="items">
        {getLoading ? (
          <ReactLoading
            type="bubbles"
            color={serviceType === 0 ? "#ff8035" : "#ffffff"}
            height={150}
            width={120}
            className="reactLoading"
          />
        ) : null}
        <JSlider2
          showArrows={true}
          numberSlidesToShow={4}
          singleItem={customer.isTablet2 ? fixItem : null}
          handleSwipe={handleSwipeChanged}
          items={getItems.map((item, index) => (
            <Product
              code={item.code}
              productImage={item.images[0]}
              serviceType={item.serviceType}
              title1={serviceType === 0 ? item.description[0] : ""}
              title2={item.description[1]}
              title3={item.description[2]}
              title4={item.description[3]}
              title5={item.description[4]}
              title6={item.description[5]}
              mainPrice={item.mainPrice}
              discountPrice={item.discountPrice}
              hasEquipment={item.equipmentCount > 0 ? true : false}
              productDes={item.productDes}
              canSelect={true}
            />
          ))}
        />
      </div>
      {!customer.isTablet2 ? fixItem : null}
    </div>
  ) : getItems.length != 0 && serviceType === -1 ? (
    <>
      {getLoading ? (
        <ReactLoading
          type="bubbles"
          color={serviceType < 1 ? "#ff8035" : "#ffffff"}
          height={150}
          width={120}
          className="reactLoading"
        />
      ) : null}
      <JSlider
        showArrows={false}
        numberSlidesToShow={1}
        items={getItems.map((item) => (
          <div
            onClick={() => {
              item.serviceType != -1
                ? handleSelectPackage(item.code, item.serviceType)
                : item.description.length > 0 &&
                  window.open(item.description[0]);
            }}
          >
            <img
              className={`imgSlider ${item.serviceType == -1 && item.description.length == 0 ? " noCursor" : ""}`}
              src={!customer.isMobile ? item.images[0] : item.images[1]}
            ></img>
          </div>
        ))}
      />

      <div className="line">
        <div className="lineL"></div>
        <div className="lineC"></div>
        <div className="lineR"></div>
      </div>
    </>
  ) : null;
};

export default MainBox;
